var map = {
	"./007-microphone-1.png": 58703,
	"./010-home.png": 67952,
	"./013-document-1.png": 41345,
	"./014-document.png": 3534,
	"./015-color-palette.png": 35943,
	"./017-video-camera.png": 43291,
	"./024-like.svg": 81311,
	"./1.svg": 31866,
	"./155-credit-card.svg": 46589,
	"./2.svg": 99977,
	"./3.svg": 12088,
	"./4.svg": 84919,
	"./New Customer.svg": 1559,
	"./NotOpen.svg": 52092,
	"./Opened.svg": 19042,
	"./Profit.svg": 52587,
	"./SalesRevenue.svg": 26229,
	"./Sent.svg": 63687,
	"./Slack.svg": 4959,
	"./address.svg": 37683,
	"./adobe.svg": 76894,
	"./arrow-left.svg": 40682,
	"./arrow-right.svg": 47969,
	"./book.svg": 41986,
	"./camera.svg": 92076,
	"./chat.svg": 95455,
	"./clipboard.svg": 33313,
	"./cloud.svg": 1248,
	"./columns.svg": 98642,
	"./documentation.svg": 97309,
	"./engineering.svg": 20726,
	"./file.svg": 14671,
	"./flat.svg": 8908,
	"./headphone.svg": 51609,
	"./iconfinder_trello_2317760.svg": 41300,
	"./idea.svg": 38168,
	"./image.png": 38774,
	"./image.svg": 52576,
	"./label.png": 84307,
	"./layers.svg": 99487,
	"./left.svg": 3902,
	"./logo2.svg": 8502,
	"./logo3.svg": 55367,
	"./logo4.svg": 52968,
	"./logo5.svg": 65337,
	"./logo6.svg": 16042,
	"./logoIn.svg": 61825,
	"./paint.svg": 99867,
	"./protection.svg": 64396,
	"./quote.png": 14873,
	"./repeat.svg": 17964,
	"./right.svg": 94045,
	"./settings.svg": 37922,
	"./strategy.svg": 39882,
	"./theme.svg": 40484,
	"./user.svg": 1080,
	"./water-fall.svg": 87168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66609;